import bill1000 from "../../../images/cash/100_dollar.png";
import bill100 from "../../../images/cash/100_dollar.png";
import bill50 from "../../../images/cash/50_dollar.png";
import bill20 from "../../../images/cash/20_dollar.png";
import bill10 from "../../../images/cash/10_dollar.png";
import bill5 from "../../../images/cash/5_dollar.png";
import bill1 from "../../../images/cash/1_dollar.png";
import coin1 from "../../../images/cash/1_dollar_bronze.png";
import coin50c from "../../../images/cash/50_cents.png";
import coin25c from "../../../images/cash/25_cents.png";
import coin10c from "../../../images/cash/10_cents.png";
import coin5c from "../../../images/cash/5_cents.png";
import coin1c from "../../../images/cash/1_cent.png";
export const cashierMockData = [
  {
    id: 49,
    drawerId: "Nguyen - drawer 01",
    branchName: "Nguyen's store",
    branchAddress: "24A Bau Cat 2",
    status: "Active",
    createdDate: "04/12/2025\n10:20:17",
    sgdTotal: "SGD 12,154.05",
    usdData: [
      {
        id: "usd100",
        label: "100 Dollars",
        value: 100,
        inventory: 3,
        total: "USD 300",
        image: bill100,
      },
      {
        id: "usd50",
        label: "50 Dollars",
        value: 50,
        inventory: 2,
        total: "USD 100",
        image: bill50,
      },
      {
        id: "usd20",
        label: "20 Dollars",
        value: 20,
        inventory: 3,
        total: "USD 60",
        image: bill20,
      },
      {
        id: "usd10",
        label: "10 Dollars",
        value: 10,
        inventory: 2,
        total: "USD 20",
        image: bill10,
      },
      {
        id: "usd5",
        label: "5 Dollars",
        value: 5,
        inventory: 3,
        total: "USD 15",
        image: bill5,
      },
      {
        id: "usd1b",
        label: "1 Dollar",
        value: 1,
        inventory: 11,
        total: "USD 11",
        image: bill1,
      },
      {
        id: "usd1c",
        label: "1 Dollar",
        value: 1,
        inventory: 2,
        total: "USD 2",
        image: coin1,
      },
      {
        id: "usd50c",
        label: "50 Cents",
        value: 0.5,
        inventory: 1,
        total: "USD 0.5",
        image: coin50c,
      },
      {
        id: "usd25c",
        label: "25 Cents",
        value: 0.25,
        inventory: "-",
        total: "USD 0.00",
        image: coin25c,
      },
      {
        id: "usd10c",
        label: "10 Cents",
        value: 0.1,
        inventory: 1,
        total: "USD 0.1",
        image: coin10c,
      },
      {
        id: "usd5c",
        label: "5 Cents",
        value: 0.05,
        inventory: 1,
        total: "USD 0.05",
        image: coin5c,
      },
      {
        id: "usd1c_coin",
        label: "1 Cent",
        value: 0.01,
        inventory: 6,
        total: "USD 0.06",
        image: coin1c,
      },
    ],
    sgdData: [
      {
        id: "sgd1000",
        label: "1000 Dollars",
        value: 1000,
        inventory: 8,
        total: "SGD 8,000",
        image: bill1000,
      },
      {
        id: "sgd100",
        label: "100 Dollars",
        value: 100,
        inventory: 23,
        total: "SGD 2,300",
        image: bill100,
      },
      {
        id: "sgd50",
        label: "50 Dollars",
        value: 50,
        inventory: 22,
        total: "SGD 1,100",
        image: bill50,
      },
      {
        id: "sgd10",
        label: "10 Dollars",
        value: 10,
        inventory: 42,
        total: "SGD 420",
        image: bill10,
      },
      {
        id: "sgd5",
        label: "5 Dollars",
        value: 5,
        inventory: 5,
        total: "SGD 25",
        image: bill5,
      },
      {
        id: "sgd2",
        label: "2 Dollars",
        value: 2,
        inventory: 2,
        total: "SGD 4",
        image: bill1,
      },
    ],
  },
  {
    id: 50,
    drawerId: "Tran - drawer 02",
    branchName: "Tran's branch",
    branchAddress: "123 Dist 1",
    status: "Inactive",
    createdDate: "03/12/2025\n08:15:00",
    sgdTotal: "SGD 1,500.00",
    usdData: [
      {
        id: "usd100",
        label: "100 Dollars",
        value: 100,
        inventory: 10,
        total: "USD 1,000",
        image: bill100,
      },
    ],
    sgdData: [
      {
        id: "sgd100",
        label: "100 Dollars",
        value: 100,
        inventory: 15,
        total: "SGD 1,500",
        image: bill100,
      },
    ],
  },
];
